import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import api from "../../api/axios";

export default function MarkMilestoneComplete({
  open,
  milestone,
  onClose,
  onSuccess,
  selectedProject,
}) {
  const [completionDate, setCompletionDate] = useState(dayjs());
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setCompletionDate(dayjs());
      setRemark("");
    }
  }, [open]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await api.post(
        "/projects/milestone/mark_complete/" + selectedProject.id,
        {
          milestoneId: milestone.milestone_id,
          completionDate: completionDate.format("YYYY-MM-DD"),
          remark,
        }
      );

      setLoading(false);
      onSuccess(); // 🔥 notify parent
      onClose();
    } catch (err) {
      console.error("Mark complete failed:", err);
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Mark Milestone Complete</DialogTitle>

      <DialogContent>
        <Stack spacing={3} mt={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Completion Date"
              value={completionDate}
              onChange={(newValue) => setCompletionDate(newValue)}
              slotProps={{
                textField: { fullWidth: true },
              }}
              disableFuture
            />
          </LocalizationProvider>

          <TextField
            label="Completion Remark (Optional)"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            multiline
            minRows={2}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
